import { Column } from "react-table";
import { TableCustomCell } from "../../../component/table/components/TableCustomCell";
import { TableCustomHeader } from "../../../component/table/components/TableCustomHeader";
import { localStorageItem } from "../../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";
import { formatMoney } from "../../../utils/FormatUtils";

const currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);

const DanhSachHDThanhToanColumns: ReadonlyArray<Column<any>> = [
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Tên hợp đồng"}
        className="text-white text-center bg-pri min-w-50px"
      />
    ),
    id: "name",
    Cell: ({ ...props }) => (
      <>
        <TableCustomCell data={props.data[props.row.index]?.contractName} />
        <TableCustomCell data={props.data[props.row.index]?.companyName} />
      </>
    ),
  },
];

const initialValuesFormThanhToanHD: any = {
  invCode: "",
  invCashier: currentUser?.name,
  invDate: new Date(),
  invTotal: "",
  loaiPhieu: null,
  hinhThuc: null,
  trangThai: "",
  orderSetDataIds: [],
};

export const ThongTinThanhToanHDColumns = [
  {
    title: "Tên gói khám",
    field: "name",
    className: "spaces w-30",
  },
  {
    title: "Đơn vị",
    field: "unit",
    className: "spaces w-10",
  },
  {
    title: "Số lượng",
    field: "quantity",
    className: "text-center spaces w-10",
    render: (row: any, index: number, stt: number) => row?.quantity,
  },
  {
    title: "Đơn giá VP",
    field: "attributes.svcFeeHospital",
    className: "text-end spaces w-10",
    render: (row: any, index: number, stt: number) => formatMoney(row?.attributes?.svcFeeHospital),
  },
  {
    title: "Đơn giá theo gói",
    field: "feePackage",
    className: "text-end spaces w-15",
    render: (row: any, index: number, stt: number) => formatMoney(row.feePackage),
  },
  {
    title: "Thành tiền",
    field: "totalFee",
    className: "text-end spaces w-15",
    render: (row: any, index: number, stt: number) => formatMoney(row.feePackage * row?.quantity),
  },
  {
    title: "Đã thu",
    field: "totalFeePaid",
    className: "text-end spaces w-15",
    cellClassName: "spaces pr-10",
    render: (row: any, index: number, stt: number) => formatMoney(row.totalFeePaid),
  },
];

export { DanhSachHDThanhToanColumns, initialValuesFormThanhToanHD };
